import { put, select } from 'redux-saga/effects';

const HEALTH_LEAD_CAPTURE_VARIANT_A_FIELD_SET = 'leadCapture.health';
const HEALTH_LEAD_CAPTURE_VARIANT_B_FIELD_SET = 'leadCapture.healthVariantB';
const HEALTH_LEAD_CAPTURE_VARIANT_C_FIELD_SET = 'leadCapture.healthVariantC';
const HEALTH_LEAD_CAPTURE_IDENTIFIER = 'leadCapture.health';
const STATE_KEY = 'vertical.quote';

const HEALTH_CROSS_SELL_FIELD_SETS = [
    HEALTH_LEAD_CAPTURE_VARIANT_A_FIELD_SET,
    HEALTH_LEAD_CAPTURE_VARIANT_B_FIELD_SET,
    HEALTH_LEAD_CAPTURE_VARIANT_C_FIELD_SET,
];

/**
 * Syncs leadCapture.health with the visibility of the health cross-sell widget
 * for all variants (A/default, B, and C).
 *
 * On SHOW_FIELD_SET (any variant): initialises leadCapture.health to 'N' (unchecked) so
 * the GTM selector always includes leadCapture: { health: false } whenever the widget is
 * visible, even if the user has not interacted with it.
 * Does NOT override an existing 'Y' or 'N' selection.
 *
 * On HIDE_FIELD_SET (variant C only): clears the value to null when the phone is removed,
 * so the GTM selector omits leadCapture entirely, mirroring the backend serialiser which
 * excludes hidden fields. Variants A and B are not phone-gated so their HIDE events do
 * not affect leadCapture state.
 * Does NOT clear when the widget hides due to page navigation (phone still has a value).
 */
const syncHealthLeadCaptureVisibilitySaga = function* (action) {
    if (!HEALTH_CROSS_SELL_FIELD_SETS.includes(action.fieldSet) || action.stateKey !== STATE_KEY) return;

    const { mobile, otherPhone, currentValue, isVariantC } = yield select((state) => ({
        mobile: state.getIn(['vertical', 'quote', 'form', 'applicant', 'mobile']),
        otherPhone: state.getIn(['vertical', 'quote', 'form', 'applicant', 'phone']),
        currentValue: state.getIn(['vertical', 'quote', 'form', 'leadCapture', 'health']),
        isVariantC: state.getIn(['page', 'experimentId']) === 'healthXSellVariantC'
            || state.getIn(['page', 'splitTrafficId']) === 'healthXSellVariantC'
    }));

    if (action.type === 'HIDE_FIELD_SET'
        && action.fieldSet === HEALTH_LEAD_CAPTURE_VARIANT_C_FIELD_SET
        && isVariantC
        && !mobile && !otherPhone) {
        yield put({ type: 'SET_VALUE', identifier: HEALTH_LEAD_CAPTURE_IDENTIFIER, value: null, stateKey: STATE_KEY });
    } else if (action.type === 'SHOW_FIELD_SET' && currentValue == null) {
        yield put({ type: 'SET_VALUE', identifier: HEALTH_LEAD_CAPTURE_IDENTIFIER, value: 'N', stateKey: STATE_KEY });
    }
};

export const syncHealthLeadCaptureVisibility = [['HIDE_FIELD_SET', 'SHOW_FIELD_SET'], syncHealthLeadCaptureVisibilitySaga];
